export default "/_next/static/media/cxPSAT.d619b2d7ad8e885728902b8cec21e2cc.mp4";